export default "__VITE_ASSET__yN9Nlg_I__"